<template>
  <div>
    <sd-header></sd-header>
    <div class="pay_view">
      <div class="inner">
        <div class="section1 block">
          <p class="title">订单详情</p>
          <div class="order">
            <ul class="order_list">
              <li v-for="item in payOrders">
                <ul class="order_info">
                  <li>订单编号：{{ item.orderNum }}</li>
                  <li>{{ item.contributionName }}</li>
                  <li>{{ item.dubboNum }}</li>
                  <li class="red">￥{{ item.appointPrice }}</li>
                </ul>
              </li>
            </ul>
            <p class="all">
              合计： <span>￥{{ totalMoney }}</span>
            </p>
          </div>
        </div>
        <div class="section2 block">
          <p class="title">使用优惠券/代金券抵用</p>
          <div class="discount">
            <ul class="choose">
              <li
                :class="{ on: discountType == 2 }"
                @click="changeDiscountType(2)"
              >
                代金券{{ dj.length }}
              </li>
              <li
                :class="{ on: discountType == 1 }"
                @click="changeDiscountType(1)"
              >
                满减券{{ yh.length }}
              </li>
            </ul>
            <div class="cop_wrap">
              <ul class="dj" v-show="discountType == 2">
                <li v-for="item in dj" @click="chooseDiscount(item)">
                  <div class="wrap" :class="{ on: selectedDiscount == item }">
                    <div class="coupon">
                      <div class="money">
                        <span class="big">{{ item.discountAmount }}</span>
                        <span class="small">￥</span>
                        <p class="full">无限制</p>
                      </div>
                      <p class="type">代金券</p>
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="yh" v-show="discountType == 1">
                <li v-for="item in yh" @click="chooseDiscount(item)">
                  <div class="wrap" :class="{ on: selectedDiscount == item }">
                    <div class="coupon">
                      <div class="money">
                        <span class="big">{{ item.discountAmount }}</span>
                        <span class="small">￥</span>
                        <p class="full">满{{ item.discountDoorsill }}元使用</p>
                      </div>
                      <p class="type">优惠券</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <p class="all">
              实付款：<span>￥{{ this.withDiscountMoney }}</span>
            </p>
            <div class="result">
              <p>
                金额抵用
                <span>￥{{ selectedDiscount.discountAmount || 0 }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="section4 block">
          <p class="title">
            当前余额：<span>￥{{ canUseMount || 0 }}</span>
          </p>
          <div v-show="canUseMount">
            <p class="title left" style="padding-top: 8px">使用余额：</p>
            <input
              type="number"
              ref="remainingMount"
              v-model="remainingMount"
              @change="changeRemainingMount"
            />
            <span style="color: #9b9b9b; margin-left: 20px"
              >请输入您要使用的金额余额，比如：100</span
            >
          </div>
        </div>
        <div class="section3 block">
          <div v-if="onlinePay > 0">
            <p class="choose">请选择以下支付方式</p>
            <p class="deadline">
              选择支付方式后，您有<span class="minute">180秒</span
              >的时间完成付款, 逾期订单自动取消
            </p>
            <ul>
              <li v-interval @click="submitPay(payWayLs[1].id)">微信支付</li>
              <li v-interval @click="submitPay(payWayLs[0].id)">支付宝支付</li>
            </ul>
          </div>
          <button v-else @click="submitPay(13)">立即支付</button>
          <p class="all">
            付款金额： <span>￥{{ onlinePay }}</span>
          </p>
        </div>
        <!-- 微信&&支付宝支付二维码弹出页 -->
        <sd-modal left="28%" top="15%" v-show="payStatus">
          <div
            class="pay_way"
            :class="{
              pay_zfb: payChannel == payWayLs[0].id,
              pay_wx: payChannel == payWayLs[1].id,
            }"
          >
            <div class="title">
              <p class="way" v-if="payChannel == payWayLs[1].id">微信支付</p>
              <p class="way" v-if="payChannel == payWayLs[0].id">支付宝支付</p>
              <p class="num">订单编号：{{ orderNums }}</p>
              <i class="close" @click="cancelPay"></i>
            </div>
            <div class="content" v-show="payStatus == 'waiting'">
              <div class="inner">
                <p class="money">
                  在线付款金额：<span>￥{{ onlinePay }}</span>
                </p>
                <div class="erwm">
                  <img
                    style="height: 200px"
                    :src="QRCode | preImgPath"
                    alt=""
                  />
                  <p class="erwm_txt" v-if="payChannel == payWayLs[1].id">
                    使用微信扫描二维码支付
                  </p>
                  <p class="erwm_txt" v-if="payChannel == payWayLs[0].id">
                    使用支付宝扫描二维码支付
                  </p>
                </div>
                <p class="remind">
                  付款成功请不要关闭此页面，付款后页面没有跳转，请根据您的情况联系客服
                </p>
                <div class="contact">
                  支付遇到问题？ 请联系客服
                  <div class="btn kf_btn">
                    <div class="kf_list_wrap">
                      <div class="kf_list">
                        <div class="arrow_top">
                          <div class="arrow_inner"></div>
                        </div>
                        <ul></ul>
                      </div>
                    </div>
                  </div>
                  或拨打电话：136-9946-5470
                </div>
              </div>
            </div>
            <div class="pay_way" v-show="payStatus == 'success'">
              <div class="content_succ">
                <div class="inner_succ">
                  <i></i>
                  <p class="wish">付款成功！祝您生活愉快！</p>
                  <p class="num">
                    <span
                      >使用余额：<span style="color: #fb3509"
                        >￥{{ remainingMount }}</span
                      ></span
                    >
                  </p>
                  <p class="num">
                    <span
                      >在线付款：<span style="color: #fb3509"
                        >￥{{ onlinePay }}</span
                      ></span
                    >
                  </p>
                  <ul>
                    <li @click="jump('OrderView')">返回订单</li>
                    <li><a href="/" target="_blank">返回首页</a></li>
                  </ul>
                  <p class="deadline">
                    <!-- <span>{{closeTime}}</span> 秒后跳转订单页面 -->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </sd-modal>
      </div>
    </div>
    <sd-footer></sd-footer>
  </div>
</template>
<script type="es6">
import { mapState, mapActions , mapGetters} from 'vuex'
import sdModal from '../components/sdModal'
import { util } from '../service/util'
import sdHeader from '../components/sdHeader'
import sdFooter from '../components/sdFooter'
let API = util.api([
    'FINDCANUSERDISCOUNT', // 交易可用的券
    'SEARCHCUSTOMERAMOUNT', // 可用余额
    'CUSTOMERSUBMITPAY',    // 提交支付
    'FINDPAYRESULTBYPAYID', // 查询订单集合支付情况
    'CLOSEPAYORDER',        // 取消支付
    'FINDLASTPAYCHANNELBYCUSTOMERID',
    'FINDONLINEPAYCHANNEL',
])

export default {
    name: 'pay-view',
    components: { sdModal,sdHeader,sdFooter },
    data () {
        return {
            oldSearchStr: '',
            // 使用余额
            remainingMount: 0,
            // 可用余额
            canUseMount: 0,
            // 支付渠道
            payChannel: '',
            // 被选中的券
            selectedDiscount: {},
            // 券类型
            discountType: '2',
            // 可用的券
            discountData: [],
            // 微信支付返回的支付二维码
            QRCode: '',
            payStatus: '',
            // 轮询的timer
            timer: '',
            // 自动关闭的时间
            closeTime: 180,
            // 临时的支付id
            payId: '',

            channelAlipay: '',
            channelWx: ''
        }
    },
    computed: {
        ...mapState({
            // 待支付订单数据
            userInfo:  state => state.common.userInfo,
            payOrders: state => state.common.payOrders,
        }),
        // 订单ids集合
        orderIds() {
            let ids = [];
            this.payOrders.forEach( d => {
                ids.push(d.id);
            })
            return ids;
        },
        // 显示用的订单编号集合
        orderNums() {
            let nums = [];
            this.payOrders.forEach( d => {
                nums.push(d.orderNum);
            })
            let numsStr = '',
                length = nums.length;
            if(length <= 3){
                numsStr = nums.join(',') + ' 共'+length+'单';
            } else {
                numsStr = nums.slice(0,3).join(',')+'... 共'+length+'单';
            }
            console.log(numsStr);
            return numsStr;
        },
        // 代金券
        dj() {
            return this.discountData.filter( d => {
                return d.discountType == 2;
            })
        },
        // 优惠券
        yh() {
            return this.discountData.filter( d => {
                return d.discountType == 1;
            })
        },
        // 订单总额
        totalMoney() {
            let money = 0;
            this.payOrders.forEach( d => {
                money += d.appointPrice;
            })
            return money;
        },
        // 扣去优惠券的款
        withDiscountMoney() {
            // 处理浮点数运算bug
            let money = (this.totalMoney*1000000 - (this.selectedDiscount.discountAmount||0)*1000000) / 1000000;
            return money < 0 ? 0 : money;
        },
        // 在线付款金额(总定价 - 优惠金额 - 余额支付)
        onlinePay() {
            return (this.withDiscountMoney*1000000 - this.remainingMount*1000000) / 1000000;
        },
        // 组成支付参数
        getPayParam() {
            let orderIds = [],
                payChannel = this.payChannel,
                remainingMount = this.remainingMount,
                couponId    = this.selectedDiscount.discountCode,
                intendMoney = this.onlinePay;
            this.payOrders.forEach( d => {
                orderIds.push(d.id);
            })
            return {
                orderIds,
                payChannel,
                remainingMount,
                couponId,
                intendMoney
            }
        },
        payWayLs() {
            return [this.channelAlipay || { id: 12 }, this.channelWx || { id: 1 }];
        },
    },
    methods: {
        toSearchPage() {
            window.open('/search/result?oldSearchStr='+this.oldSearchStr);
        },
        // 跳转
        jump(name) {
            this.$router.push({
                name: name
            })
        },
        // 切换优惠券类型
        changeDiscountType(type) {
            this.selectedDiscount = {};
            this.discountType = type;
        },
        // 选择优惠券
        chooseDiscount(discount) {
            if(this.selectedDiscount == discount){
                this.selectedDiscount = {};
            } else {
                this.selectedDiscount = discount;
            }
            // 清除余额价格
            this.remainingMount = 0;
            // this.$refs.remainingMount.value = 0;
        },
        // 使用余额变动
        changeRemainingMount($e){
            // let money = parseFloat($e.target.value);
            let money = parseInt($e.target.value);
            // 小于0和错误
            if(!money || money < 0.0){
                money = 0.0;
            }
            // 大于可用余额
            if(money > this.canUseMount){
                money = this.canUseMount;
            }
            // 超过待支付金额
            if(money > this.withDiscountMoney){
                money = this.withDiscountMoney;
            }
            $e.target.value = money;
            this.remainingMount = money;
        },
        /**
         * 选择其他付款方式
         * - 解锁订单
         */
        cancelPay() {
            // 支付成功
            if(this.payStatus == 'success'){
                this.closePayresult();
                this.jump('OrderView');
            } else {
                // 支付中
                util.kAjax(API.CLOSEPAYORDER, { payId: this.payId }, res => {
                    clearInterval(this.timer);
                    this.closePayresult();
                })
            }
        },
        /**
         * 关闭支付成功窗口
         */
        closePayresult() {
            this.payStatus = '';
            this.QRCode = '';
        },
        // 轮询支付结果
        checkPayResult() {
            setInterval(this.timer);
            this.closeTime = 180;
            this.timer = setInterval(() => {
                util.kAjax(API.FINDPAYRESULTBYPAYID, {payId:this.payId}, res => {
                    this.closeTime -= 2;
                    if(this.closeTime  <= 0){
                        // 清空时长
                        clearInterval(this.timer);
                        // 关闭窗口
                        this.payStatus = '';
                        this.QRCode = '';
                    }
                    // 支付成功
                    if(res.data == 2){
                        this.payStatus = 'success';
                        this.QRCode = '';
                        clearInterval(this.timer);
                    }
                })
            },2000)
        },
        // 提交订单
        submitPay(payChannel) {
            // 支付渠道
            this.payChannel = payChannel;
            // 获取支付参数
            let param = this.getPayParam;
            util.kAjax(API.CUSTOMERSUBMITPAY, param, res => {

                // 完全余额支付
                if(!res.data){
                    // 支付成功
                    this.payStatus = 'success';
                    return;
                }

                // 获取临时支付id, 余额支付
                this.payId = res.data.payId;

                 // 显示微信支付二维码
                 this.QRCode = res.data.html;
                    this.payStatus = 'waiting';
                    // 轮询支付结果
                    this.checkPayResult();
            })
        },
        getChannel(){
            util.kAjax(API["FINDLASTPAYCHANNELBYCUSTOMERID"], {}, ({data = []}) => {
                let channel = data[0] ? data[0] : undefined;
              if (!channel) return;
              util.kAjax(API["FINDONLINEPAYCHANNEL"], {
                  tagId: +channel.tagId,
                }, ({data = []}) => {
                    this.channelWx = data.find((d) => d.onLineType == 1);
                    this.channelAlipay = data.find((d) => d.onLineType == 2);
                })
            })
        }
    },
    created() {
        // 无订单信息，返回订单页面
        if(!this.payOrders.length){
            this.$router.push({
                name: 'OrderView'
            })
            return;
        }
        // 获取用户可用的优惠券
        util.kAjax(API.FINDCANUSERDISCOUNT,{ orderIds: this.orderIds }, json => {
            this.discountData = json.data;
        })
        // 获取余额
        util.kAjax(API.SEARCHCUSTOMERAMOUNT, {}, json => {
            this.canUseMount = json.data;
        })
        this.getChannel()
    },
    mounted(){

    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
}
</script>



// WEBPACK FOOTER //
// PayView.vue?45facab9